
import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from "@/components/ui/input";
import { ControllerRenderProps } from "react-hook-form";

// Update the props interface to include the direct field prop
interface PasswordInputFieldProps {
  field: ControllerRenderProps<any, any>;
  label?: string;
  description?: string;
  placeholder?: string;
  isLoading?: boolean;
  autoComplete?: string;
}

export const PasswordInputField: React.FC<PasswordInputFieldProps> = ({
  field,
  label,
  description,
  placeholder = "••••••••",
  isLoading = false,
  autoComplete = "new-password"
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="relative">
      <Input
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        className="pr-10"
        {...field}
        disabled={isLoading}
        autoComplete={autoComplete}
      />
      <button aria-label={showPassword ? "Hide password" : "Show password"} 
        type="button"
        onClick={togglePasswordVisibility}
        className="absolute inset-y-0 right-0 pr-3 flex items-center text-muted-foreground"
        disabled={isLoading}
      >
        {showPassword ? (
          <EyeOff className="h-4 w-4" />
        ) : (
          <Eye className="h-4 w-4" />
        )}
      </button>
    </div>
  );
};
